import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import API from "../../../Network/API";
import { PLAN_HIGHLIGHTS, formatPlanDate, storeUser } from "./Subscription";

// After Stripe Checkout: the backend verifies the session with Stripe and activates the plan.
export default function SubscriptionComplete() {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const dispatch = useDispatch();
    const prefix = location.pathname.startsWith("/app") ? "/app" : "";
    const sessionId = new URLSearchParams(location.search).get("session_id");
    const [state, setState] = useState("checking");
    const [message, setMessage] = useState("");
    const [plan, setPlan] = useState(null);
    const sent = useRef(false);

    useEffect(() => {
        if (sent.current) return;
        sent.current = true;
        if (!sessionId) {
            setState("failed");
            return;
        }
        API.post(`/v1/oauth/teacher/subscription/confirm`, { session_id: sessionId })
            .then((response) => {
                storeUser(dispatch, response.data?.data?.user);
                setPlan(response.data?.data?.subscription || null);
                setState("done");
            })
            .catch((err) => {
                setMessage(err?.response?.data?.message || "");
                setState("failed");
            });
    }, [sessionId, dispatch]);

    if (state === "checking") {
        return (
            <div className="sco-state">
                <span className="spinner-border" role="status" aria-hidden="true" />
                <h4>{t("subscriptionComplete.confirming")}</h4>
                <p>{t("subscriptionComplete.dont_close")}</p>
            </div>
        );
    }

    if (state === "failed") {
        return (
            <div className="sco-state is-error">
                <i className="fa-solid fa-circle-xmark" />
                <h4>{t("subscriptionComplete.not_completed")}</h4>
                <p>{message || t("subscriptionComplete.not_completed_hint")}</p>
                <Link to={`${prefix}/dashboard/subscription`} className="btn subscribe-btn">{t("subscriptionComplete.try_again")}</Link>
            </div>
        );
    }

    return (
        <div className="sco-state is-success">
            <i className="fa-solid fa-circle-check" />
            <h4>{plan?.on_trial ? t("subscriptionComplete.trial_welcome") : t("subscriptionComplete.welcome")}</h4>
            <p>{plan?.on_trial ?
                t("subscriptionComplete.trial_active", { date: formatPlanDate(plan.trial_ends_at, i18n.resolvedLanguage || i18n.language), price: plan.price })
                : t("subscriptionComplete.active_now")}</p>
            <ul className="sco-features sco-features--center">
                {PLAN_HIGHLIGHTS.map((f) => (
                    <li key={f.text}><i className="fa-solid fa-circle-check" /><span>{t(f.text)}</span></li>
                ))}
            </ul>
            <div className="sco-actions">
                <Link to={`${prefix}/dashboard/tutor`} className="btn subscribe-btn">{t("subscriptionComplete.go_dashboard")}</Link>
                <Link to={`${prefix}/dashboard/subscription`} className="btn btn-outline-dark">{t("subscriptionComplete.view_plan")}</Link>
            </div>
            <p className="sco-receipt">{plan?.on_trial ? t("subscriptionComplete.trial_receipt_note") : t("subscriptionComplete.receipt_note")}</p>
        </div>
    );
}
